import Request from './request'

const Device_Group = {
  updateGroup (params, callback) {
    Request.post('device-group/update', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateParentGroup (params, callback, bad_answer) {
    Request.post('device-group/update-parent', JSON.stringify(params)).then(callback).catch(bad_answer)
  },
  getGroupList (callback) {
    Request.get('device-group/index').then(callback).catch(this.bad_answer)
  },
  createDeviceGroup (params, callback) {
    Request.post('device-group/create', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  deleteDeviceGroup (params, callback) {
    Request.post('device-group/delete', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getListDevicesByIdGroup (params, callback) {
    Request.post('device-group/devices-by-id', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getUsersGroup (id, callback) {
    Request.post('device-group/users/' + id).then(callback).catch(this.bad_answer)
  },

  getInfoDeviceGroup (group_id, callback) {
    Request.get('device-group/view/' + group_id).then(callback).catch(this.bad_answer)
  },
  saveDeviceGroupConfig (params, callback) {
    Request.post('device-group/save-config', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default Device_Group
